export default "__VITE_ASSET__b4b7b1c8__"